import { ExposedPersonDTOSchema } from '@doutorsim/shared/persons'
import { z } from 'zod'

export const CreateGuarantorFormSchema = z.object({
  name: ExposedPersonDTOSchema.shape.name,
  cpf: ExposedPersonDTOSchema.shape.cpf,
  phone: ExposedPersonDTOSchema.shape.phone.unwrap(),
  email: ExposedPersonDTOSchema.shape.email.unwrap(),
})

export type TCreateGuarantorForm = z.infer<typeof CreateGuarantorFormSchema>
